/* globals DOMStringList, Clipboard */

/**
 * This method checks to see if the user has dragged the element outside of the window.
 *
 * @param {Object} event - browser generated drag event
 * @returns {boolean} whether the drag event has left the window
 */
function isDraggedOutsideWindow(event) {
  return event.clientX <= 0 || event.clientY <= 0 || event.clientX >= window.innerWidth || event.clientY >= window.innerHeight;
}
/**
 * This method gets the first file from a file system drag event
 *
 * @param {Object} event - browser generated drag event
 * @returns {File} the file being dragged
 */


function getFirstFile(event) {
  return event.dataTransfer && event.dataTransfer.files[0];
}
/**
 * This method detects whether the drag source is an external file given a
 * data transfer object
 *
 * @param {object} dataTransfer - browser generated dataTransfer object (part of the drag event)
 * @returns {binary} whether what is being dragged is a file from the users file system or not
 */


function isFileSystemDrag(event) {
  var dataTransfer = event.dataTransfer || {};
  var dragDataType = dataTransfer.types || {}; // Source detection for Safari v5.1.7 on Windows / Mac.

  if (typeof Clipboard !== 'undefined' && dataTransfer.constructor === Clipboard) {
    return dataTransfer.files.length > 0;
  } // Source detection for Firefox on Windows / Mac.


  if (typeof DOMStringList !== 'undefined' && dragDataType.constructor === DOMStringList) {
    return !dragDataType.contains('text/html') && dragDataType.contains('Files');
  } // Source detection for Chrome on Windows / Mac.


  if (typeof Array !== 'undefined' && dragDataType.constructor === Array) {
    return dragDataType.indexOf('Files') !== -1;
  }

  return false;
}
/**
 * This method sets up which cursor icons can be used when dragging a file
 *
 * @param {object} event - browser generated drag event
 */


function setEffectAllowed(event) {
  if (event && event.dataTransfer) {
    // eslint-disable-next-line
    event.dataTransfer.effectAllowed = 'copyMove';
  }
}
/**
 * This method sets up which cursor icons is used
 *
 * @param {object} event - browser generated drag event
 */


function styleCursor(event) {
  if (isFileSystemDrag(event)) {
    // eslint-disable-next-line
    event.dataTransfer.dropEffect = 'copy';
  } else {
    // eslint-disable-next-line
    event.dataTransfer.dropEffect = 'none';
  }
}

export default {
  isDraggedOutsideWindow: isDraggedOutsideWindow,
  getFirstFile: getFirstFile,
  isFileSystemDrag: isFileSystemDrag,
  setEffectAllowed: setEffectAllowed,
  styleCursor: styleCursor
};